<template>
  <v-layout v-if="isShow" row px-2 mt-2 :justify-end="right">
    <v-icon color="primary_ink">error_outline</v-icon>
    <p class="mb-0 ml-2 color-red">
      {{ warningText }}
    </p>
  </v-layout>
</template>

<script>
export default {
  name: 'WarningText',
  props: {
    isShow: { type: Boolean, required: true },
    warningText: { type: String, required: true },
    right: { type: Boolean, required: false, default: false }
  }
};
</script>

<style scoped></style>
